import { produce } from 'immer';

import { SaveImportExportWizardSuccess } from '../../actions/importExportWizard/saveImportExportWizardSuccess';
import { ImportExportWizardState, ImportExportWizardStatus } from '../../typings/importExportWizard';

export function saveImportExportWizardSuccess(
    state: ImportExportWizardState,
    action: SaveImportExportWizardSuccess
): ImportExportWizardState {
    return produce(state, draft => {
        draft.status = ImportExportWizardStatus.SAVED;
    });
}
